<template>
	<div>
		<div class="row">
			<div class="col-md-8">
				Products:
				<br />
				<multiselect
					v-model="productIds"
					:options="searchedProducts"
					multiple
					:close-on-select="false"
					track-by="id"
					label="name"
					group-values="options"
					group-label="group_name"
					:internal-search="false"
					@search-change="doSearch"
				>
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :title="props.option.name">
							<small class="multiselect__tag-small">{{ props.option.venueName }}</small>
							<p class="multiselect__tag-text">{{ props.option.name }}</p>
							<i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect>
				<small>Save deal to populate products.</small>
			</div>
			<div class="col-md-4">
				<div class="row">
					<div class="col-md-12">
						Limit Redemptions
						<div class="d-flex mb-3">
							<input type="number" min="0" v-model="rule.settings.limit" class="form-control" />
						</div>
								Within:
						<div class="d-flex">
								<div class="col-md-5">
									<select class="delay input-small form-control" v-model="rule.settings.frequency">
										<option v-for="delay in 365" :value="delay" :key="delay">{{ delay }}</option>
									</select>
								</div>
								<div class="col-md-5">
									<select class="delayType input-small form-control" v-model="rule.settings.frequency_type">
										<option v-for="type in types" :value="type" :key="type">{{ type }}</option>
									</select>
								</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		rule: {
			type: Object,
			required: true,
		},
		products: {
			type: Array,
			required: true,
		},
		deal: {
			type: Object,
		}
	},
	data() {
		return {
			types: ["years", "months", "days", "hours", "minutes"],
			afters: ["redemption", "purchase"],
			searchedProducts: [],
			dataError: false
		};
	},
	computed: {
		dealProductIds() {
			return this.deal.products.map(p => p.product_id);
		},
		filteredProducts() {
			let prods = [];
			this.products.forEach((group) => {
				let filtered = group.options.filter((option) => this.dealProductIds.indexOf(option.id) > -1 );
				if (filtered.length > 0) prods.push({ group_name: group.group_name, options: filtered });
			});
			return prods;
		},
		productIds: {
			get() {
				let values = [];
				this.products.forEach((group) => {
					let filtered = group.options.filter((option) => {
						return (
							this.rule.settings.product_ids.map(Number).indexOf(option.id) > -1
						);
					});
					if (filtered.length > 0) values = values.concat(filtered);
				});
				return values;
			},
			set(newVal) {
				this.rule.settings.product_ids = newVal.map((v) => v.id);
			},
		},
	},
	methods: {
		doSearch(query) {
			if (query === "") this.searchedProducts = this.filteredProducts;
			else {
				const options = {
					ignoreFieldNorm: true,
					ignoreLocation: true,
					threshold: 0.0,
					keys: ["group_name", "options.name"],
				};
				const fuse = new Fuse(this.filteredProducts, options);
				this.searchedProducts = fuse.search(query).map((res) => res.item);
			}
		},
	},
	created() {
		this.searchedProducts = this.filteredProducts;
	},
	mounted() {
		let vm = this;

		Vue.nextTick(() => {
			// setup defaults
			vm.rule.settings = _.extend(
				{ limit:0, frequency: 1, frequency_type: "years"},
				vm.rule.settings
			);
			vm.$forceUpdate();
		});
	},
};
</script>

<style scoped>

</style>